/** Return a safe CSS color for a task tag. */
export function get_tag_color(tag) {
  return /^#[0-9a-f]{6}$/i.test(tag?.color || '') ? tag.color : '#6C757D';
}

/** Return accessible foreground and background styles for a task-tag chip. */
export function get_tag_style(tag) {
  const color = get_tag_color(tag);
  const [red, green, blue] = [1, 3, 5].map(index => parseInt(color.slice(index, index + 2), 16));
  const isLight = ((red * 299 + green * 587 + blue * 114) / 1000) > 160;

  return { // NOPMD -- PMD falsely treats a returned object literal as a block.
    backgroundColor: color,
    borderColor: color,
    color: isLight ? '#212529' : '#FFFFFF'
  };
}
